import { ContentLayout } from "components/generic";
import { useIntl } from "react-intl";
import UsersPageUsersTab from "tabs/userspageuserstab";

const UsersPage = () => {
  const intl = useIntl();

  const tabs: any[] = [
    {
      id: "users",
      title: "Users",
      content: () => <UsersPageUsersTab/>,
    }
  ];

  return <ContentLayout title={`${intl.formatMessage({ id: "app.users.users_admin" })}`} tabs={tabs} showTabs={false} />;

};

export default UsersPage;
